import { BaseModal, Button, Input } from '@cokitchen/cokitchen-components';
import React, { useEffect, useState } from 'react';
import './style.scss';
import { KeywordType } from 'components/metadata-keyword';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string, popular: boolean, mealId: string) => void;
  type?: 'create' | 'edit';
  mealId: string;
  selectedMetadata?: KeywordType | null;
  title: string;
};
const CreateKeywordModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedMetadata,
  type = 'create',
  mealId,
  title
}: Props) => {
  const [popular, setPopular] = useState(false);
  const [mealName, setMealName] = useState('');
  useEffect(() => {
    if (type === 'create') {
      setMealName('');
      setPopular(false);
    } else {
      setMealName(selectedMetadata?.name ?? '');
      setPopular(selectedMetadata?.popular ?? false);
    }
  }, [selectedMetadata]);

  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={() => {
        setMealName('');
        setPopular(false);
        onClose();
      }}
      title={`
        ${type === 'create' ? 'Create' : 'Edit'} ${title}`}>
      <Input
        label={title}
        placeholder={`Enter ${title}`}
        inputClass='h-[50px]'
        className='text-sm'
        value={mealName}
        onChange={(e) => setMealName(e.target.value)}
      />
      <div className='w-full flex justify-end mt-1'>
        <div className='text-xs flex justify-end gap-2 w-fit items-center border border-[#C4C4C4] rounded-[4px] p-1'>
          <button
            className={`w-4 h-4  outline-none placeholder:tracking-[1px] tracking-[1px] border-[#C4C4C4] border rounded-[4px]  p-1 grow ${
              popular ? 'bg-[#C4C4C4] ' : ''
            }`}
            onClick={() => setPopular(!popular)}
          />
          <p className='text-[#858585]'>Set as popular </p>
        </div>
      </div>

      <Button
        variant='block'
        color='primary'
        className='w-full h-[50px] text-sm font-semibold !mt-4'
        onClick={() => {
          onSubmit(mealName, popular, mealId);
          onClose();
          setMealName('');
          setPopular(false);
        }}>
        {type === 'create' ? 'Create' : 'Update'} {title}
      </Button>
    </BaseModal>
  );
};

export default CreateKeywordModal;
